module.exports = __webpack_public_path__ + "media/hph-26-01_student-success.cb264f31.webm";